'use client';
import { useEffect, useState } from "react";
import { useUser } from "@/app/context/UserContext";
import { iProConfig, iProConfigParams, iProPromptParams } from "@/app/models/interfaceProject";
import ButtonChat from "../Elements/Core/ButtonChat";
import { Action } from "@/app/constants/enums";
import InputChat from "../Elements/Core/InputChat";
import TextareaChat from "../Elements/Core/TextareaChat";
interface ConfigProjectForm {
  isOpen: boolean;
  onClose: () => void;
  initialData?: iProConfig;
}

const ConfigProject: React.FC<ConfigProjectForm> = ({ isOpen, onClose, initialData }) => {
  const { userProject, setUserProject } = useUser(); 
  const [activeTab, setActiveTab] = useState(0); 
  const [fmrValid, setFmrValid] = useState(false); 


  useEffect(() => {
    if (initialData?.prompt_params && isOpen) {
      setFormData(initialData.prompt_params);
    }

    if (initialData?.config_params && isOpen) { 
        const initialDataCopnfig = {
            temperature: initialData.config_params.temperature,
            k_top_retrieval: initialData.config_params.k_top_retrieval,
            max_token_history: initialData.config_params.max_token_history,
            k_top_history: initialData.config_params.k_top_history,
            max_minutes: initialData.config_params.max_minutes
        }; 
        setSliderData(initialDataCopnfig); 
      }
  }, [isOpen]);

  // Formulario 1 (PromptParams)
  const [formData, setFormData] = useState<iProPromptParams>({
    assistant_name: "",
    assistant_role: "",
    company_activity: "",
    company_name: "",
    conversation_purpose: "",
    welcome_message:"",
    alias:"",
  });

  const [errors, setErrors] = useState({
    assistant_name: false,
    assistant_role: false,
    company_activity: false,
    company_name: false,
    conversation_purpose: false,
  });

  const handleFormDataChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setErrors({
      ...errors,
      [e.target.name]: e.target.value === "",
    });
  }; 
  
  const [sliderData, setSliderData] = useState({
    temperature: 0.0,
    k_top_retrieval: 0.0,
    max_token_history: 0.0,
    k_top_history: 0.0  ,
    max_minutes: 10,
  });


  const handleSliderChange = (name: string, value: number) => {
    setSliderData((prev) => ({ ...prev, [name]: value }));
  };

  const validarError=()=>{
    const newErrors = {
        assistant_name: !formData.assistant_name,
        assistant_role: !formData.assistant_role,
        company_activity: !formData.company_activity,
        company_name: !formData.company_name,
        conversation_purpose: !formData.conversation_purpose,
        }; 
    //setErrors(newErrors);
    return Object.values(newErrors).every((error) => !error);
  };
  
  useEffect(() => {
    setFmrValid(validarError());
  }, [errors]);

  const saveData = () => {         
        if ( validarError() ) {
            const config = {
                k_top_history: sliderData.k_top_history,
                k_top_retrieval: sliderData.k_top_retrieval,
                max_minutes: sliderData.max_minutes, ///initialData?.config_params.max_minutes,
                max_token_history: sliderData.max_token_history,
                model_name: initialData?.config_params.model_name, ///
                temperature: sliderData.temperature
            } as iProConfigParams;
            const updatedProject = {
            ...userProject,
            config: {
                ...userProject.config,
                prompt_params: formData,
                config_params: config,
            }
            };
            setUserProject(updatedProject);
            onClose();
        }
    };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-start justify-center bg-gray-800 bg-opacity-50 z-50 ">
      <div className="mt-20 relative  bg-white rounded-lg n-card-modal shadow-lg pl-6 pr-6 pb-0 pt-0 lg:w-3/6 sm:w-full md:w-full animate-fadeIn">
        <div className="flex justify-between items-center mb-0">
            <h2 className="text-xl font-semibold">Configuración</h2>
            <ButtonChat
              actionCode={Action.CENTER_CONFIG_CLOSE} 
              onClick={onClose} 
                className="text-gray-500 hover:text-gray-700 text-5xl"
                >
                &times;
            </ButtonChat>
        </div>

        {/* Tabs Header */}
        <div className="flex border-b">
          <button
            className={`w-1/2 py-2 ${activeTab === 0 ? "border-b-2 border-blue-500 font-bold" : ""}`}
            onClick={() => setActiveTab(0)}
          >
            Agente
          </button>
          <button
            className={`w-1/2 py-2 ${activeTab === 1 ? "border-b-2 border-blue-500 font-bold" : ""}`}
            onClick={() => setActiveTab(1)}
          >
            Avanzada
          </button>
        </div>

        {/* Tabs Content */} 
         <div className="relative overflow-hidden h-80 overflow-y-auto">
          <div
            className={` absolute inset-0 transition-transform duration-500 ${
              activeTab === 0 ? "translate-x-0" : "-translate-x-full"
            }`}
          >
            <form className="grid grid-cols-1 md:grid-cols-2 gap-4 p-5 pb-0">
                <div>
                    <label className="block text-sm font-medium">Nombre Asistente</label>
                    <InputChat
                      actionCode={Action.CENTER_CONFIG_AGENTE_NAME} 
                      type="text"
                      name="assistant_name"
                      value={formData.assistant_name}
                      onChange={handleFormDataChange}
                      className={`w-full p-2 border n-fmr-input ${
                          errors.assistant_name ? 'border-red-500' : 'border-gray-300'
                      } focus:outline-none focus:ring-1 focus:ring-blue-700`}
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium">Rol Asistente</label>
                    <InputChat
                      actionCode={Action.CENTER_CONFIG_AGENTE_ROL} 
                      type="text"
                      name="assistant_role"
                      value={formData.assistant_role}
                      onChange={handleFormDataChange}
                      className={`w-full p-2 border n-fmr-input ${
                          errors.assistant_role ? 'border-red-500' : 'border-gray-300'
                      } focus:outline-none focus:ring-1 focus:ring-blue-700`}
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium">Nombre Compañia</label>
                    <InputChat
                      actionCode={Action.CENTER_CONFIG_AGENTE_COMPANIA} 
                      type="text"
                      name="company_name"
                      value={formData.company_name}
                      onChange={handleFormDataChange}
                      className={`w-full p-2 border n-fmr-input ${
                          errors.company_name ? 'border-red-500' : 'border-gray-300'
                      } focus:outline-none focus:ring-1 focus:ring-blue-700`}
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium">Actividad Compañia</label>
                    <InputChat
                      actionCode={Action.CENTER_CONFIG_AGENTE_COMPANIA_ACTVIDAD} 
                      type="text"
                      name="company_activity"
                      value={formData.company_activity}
                      onChange={handleFormDataChange}
                      className={`w-full p-2 border n-fmr-input ${
                          errors.company_activity ? 'border-red-500' : 'border-gray-300'
                      } focus:outline-none focus:ring-1 focus:ring-blue-700`}
                    />
                </div>
                <div className="col-span-1 md:col-span-2">
                    <label className="block text-sm font-medium">Propósito de la Conversación</label>
                    <TextareaChat
                      actionCode={Action.CENTER_CONFIG_AGENTE_PROPOSITO} 
                      name="conversation_purpose"
                      value={formData.conversation_purpose}
                      onChange={handleFormDataChange}
                      rows={3}
                      className={`w-full p-2 pb-0 border n-fmr-input ${
                          errors.conversation_purpose ? 'border-red-500' : 'border-gray-300'
                      } focus:outline-none focus:ring-1 focus:ring-blue-700`}
                    />
                </div>
            </form>
          </div>
          <div
            className={`absolute inset-0 transition-transform duration-500 flex justify-center items-center ${
              activeTab === 1 ? "translate-x-0" : "translate-x-full"
            }`}
          >
            <div className="grid grid-cols-1 gap-6 pt-5 w-96">
            {[
              { name: "temperature", label: "Temperatura", min: 0, max: 1.00, factor: 0.01, step: 0.01, decimals: true, actionCode:Action.CENTER_CONFIG_AVANZADO_TEMPERATURE },
              { name: "k_top_retrieval", label: "K-Top Retrieval", min: 1, max: 20, factor: 1, step: 1, decimals: false, actionCode:Action.CENTER_CONFIG_AVANZADO_RETRIVAL },
              { name: "max_token_history", label: "Max Token History", min: 0, max: 1000, factor: 1, step: 1, decimals: false, actionCode:Action.CENTER_CONFIG_AVANZADO_TOKEN },
              { name: "k_top_history", label: "K-Top History", min: 0, max: 100, factor: 1, step: 1, decimals: false, actionCode:Action.CENTER_CONFIG_AVANZADO_TOP},
              { name: "max_minutes", label: "Tiempo de expiración de sesión", min: 10, max: 1440, factor: 1, step: 10, decimals: false, actionCode:Action.CENTER_CONFIG_AVANZADO_TOP},
            ].map(
              ({ name, label, min, max, factor, step, decimals, actionCode }) => (                
                <div key={name}>
                  <label className="block flex justify-between">
                    <span className="text-sm font-medium">{label}</span>
                    <span className="text-sm font-bold">
                      {decimals
                        ? (sliderData[name as keyof typeof sliderData] || 0).toFixed(2)
                        : Math.round(sliderData[name as keyof typeof sliderData] || 0)}{" "}
                      / {max}
                    </span>
                  </label>
                  <InputChat
                    actionCode={actionCode} 
                    type="range"
                    min={min}
                    max={max}
                    step={step}
                    value={sliderData[name as keyof typeof sliderData] || 0}
                    onChange={(e) =>
                      handleSliderChange(name, parseFloat(e.target.value))
                    }
                    className="w-full"
                  />
                </div> 
               )
            )
            }
            </div>

           

          </div>
        </div>

        {/* Footer */}
        <div className="p-4 pb-2 border-t flex justify-end">
          <ButtonChat
            actionCode={Action.CENTER_CONFIG_CLOSE}
            onClick={onClose}
            className="bg-gray-200 hover:bg-gray-300 text-gray-700 py-2 px-4 mr-2 n-fmr-input focus:outline-none focus:ring-1 focus:ring-blue-700"
          >
            Cancelar
          </ButtonChat>
          <ButtonChat
            actionCode={Action.CENTER_CONFIG_SAVE}
            onClick={saveData}
            className={` text-white py-2 px-4 n-fmr-input bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-1 focus:ring-blue-700`} 
          >
            Guardar
          </ButtonChat>
        </div>
      </div>
    </div>
  );
};

export default ConfigProject;
